<template>
  <div>
    <table>
      <tr>
        <td v-if="!data.findWithoutDate">
          <section>
            <p>Start Date</p>
            <el-date-picker
              v-model="data.tglAwal"
              type="date"
              size="mini"
              placeholder="Pick a Date"
              :picker-options="$$pickerOptionsDate()"
            >
            </el-date-picker>
          </section>
        </td>
        <td v-if="!data.findWithoutDate">
          <section class="ml-2">
            <p>End Date</p>
            <el-date-picker
              v-model="data.tglAkhir"
              type="date"
              size="mini"
              placeholder="Pick a Date"
              :picker-options="$$pickerOptionsDate()"
            >
            </el-date-picker>
          </section>
        </td>
        <td>
          <section class="ml-2">
            <el-button
              @click="cekTanggal()"
              size="mini"
              type="primary"
              icon="el-icon-search"
              circle
            ></el-button>
          </section>
        </td>
        <td>
          <section class="ml-2">
            <el-checkbox v-model="data.findWithoutDate" @input="changeFind">
              Cari Tanpa Tanggal
            </el-checkbox>
          </section>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import XLSX from "xlsx";
export default {
  mounted() {},

  data() {
    return {
      data: {
        tglAkhir: new Date(),
        tglAwal: new Date(),
        findWithoutDate: false,
      },
    };
  },
  methods: {
    changeFind() {
      this.$emit("changeFind", this.data.findWithoutDate);
    },
    getDate() {
      return {
        tglAwal: this.data.tglAwal,
        tglAkhir: this.data.tglAkhir,
      };
    },
    cekTanggal() {
      if (this.data.tglAwal > this.data.tglAkhir) {
        this.data.tglAwal = this.data.tglAkhir;
        this.$vs.notify({
          text: "Silahkan isi Tanggal periode yang sesuai",
          color: "warning",
        });
        return;
      }
      this.$emit("changeDate", {
        tglAwal: this.data.tglAwal,
        tglAkhir: this.data.tglAkhir,
      });
    },
  },
};
</script>
